import Icon from "@ant-design/icons";

import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;
const TransformSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m16 23l-4-4l1.4-1.45l1.6 1.6V17H9q-.825 0-1.413-.588T7 15V9H2V7h5V4.85l-1.6 1.6L4 5l4-4l4 4l-1.4 1.45L9 4.85V15h13v2h-5v2.15l1.6-1.6L20 19l-4 4Zm-1-10V9h-4V7h4q.825 0 1.413.588T17 9v4h-2Z"
    />
  </svg>
);
const TransformIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TransformSvg} {...props} />
);
export default TransformIcon;
